import React, { useState } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { graphql, useStaticQuery } from 'gatsby'
import { pushDataLayerEvent, pushGtagEvent } from '../../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../../shared/utils/userInfo'
import { gothic, lonchmara } from '../../../_shared/Variables.module.scss'
import useBrowserMode from '../../../hooks/useBrowserMode'
import useHomeLinkMode from '../../../hooks/useHomeLinkMode'
import useLocaleMode from '../../../hooks/useLocaleMode'
import ProductService from '../../../services/products'
import SessionService from '../../../services/session'
import { convertText } from '../../../utils/convertFirstCharacterToUppercase'
import CheckIcon from '../../atoms/check-icon/check-icon'
import DynamicImage from '../../atoms/dynamic-image/dynamic-image'
import ModalRetails from '../../molecules/modal-retails/modal-retails'
import './cardProduct.scss'

const CardProduct = ({
	isFreeSamples,
	isShortCard = false,
	dataLayerbody,
	producto,
	samplesSent,
	ismobile,
	samples,
	dropsColor,
	likesInfo,
	actionCard,
	modeAction,
	noHeight,
	noFooter,
	slug,
	isSent,
	idProduct,
	setlocalLikes,
	isLocalLiked,
	onClickShop,
	onClick,
	setModalShop
}) => {
	const { homeLink } = useHomeLinkMode()
	const { locale } = useLocaleMode()
	const indexProduct = dataLayerbody.params?.items[0]?.index || 0

	const query = useStaticQuery(graphql`
		query REDIRECTION {
			allContentfulTenaHome {
				nodes {
					node_locale
					retailsDeCompra {
						redireccionRetail
					}
				}
			}
		}
	`)

	const imgProducto =
		producto && producto.imagenProductoPrevisualizacion
			? producto.imagenProductoPrevisualizacion[ismobile ? 1 : 0]
			: { file: {} }

	const imgMuestra = producto && producto.imagenMuestraPrevisualizacion
	const tallas = producto && producto.talla
	const samplesFound = samples.filter(sample =>
		[producto.id, producto.codigoDeProducto].includes(sample.id)
	)
	const { isBrowser } = useBrowserMode()
	const filterSend = tallas
		? (samplesSent &&
				samplesSent.filter(
					sample =>
						tallas.includes(sample.size) &&
						[producto.id, producto.codigoDeProducto].includes(sample.id)
				)) ||
		  []
		: []

	const homeQueryRedirection =
		isBrowser &&
		query &&
		query.allContentfulTenaHome.nodes.filter(node => node.node_locale === locale)[0]

	const isSelectedSample = tallas
		? samplesFound.length + filterSend.length === tallas.length
		: samplesFound.length > 0
	const ctaMuestraEnviada = 'MUESTRA ENVIADA'

	const renderDrops = (drops, activeDrops) => {
		const nodeArray = []
		for (let index = 0; index < Number(drops); index++) {
			nodeArray.push(
				<svg key={index} width='24' height='35' viewBox='0 0 24 35'>
					<linearGradient id='grad1' x1='0%' y1='0%' x2='0%' y2='100%'>
						<stop
							offset='50%'
							style={{
								stopColor: dropsColor ? dropsColor : gothic,
								stopOpacity: 1,
							}}
						/>
						<stop offset='50%' style={{ stopColor: lonchmara, stopOpacity: 1 }} />
					</linearGradient>
					<path
						className={
							index < Number(activeDrops)
								? activeDrops % 1 === 0.5 && parseInt(index + 0.5) === parseInt(activeDrops)
									? 'f-drop--active-medium'
									: 'f-drop f-drop--active'
								: 'f-drop'
						}
						d='M16.68,36.747A11.919,11.919,0,0,1,5,24.586C5,15.465,16.68,2,16.68,2S28.36,15.465,28.36,24.586A11.919,11.919,0,0,1,16.68,36.747Z'
						transform='translate(-5 -2)'
						fill={
							activeDrops % 1 === 0.5 && parseInt(index + 0.5) === parseInt(activeDrops)
								? 'url(#grad1)'
								: 'none'
						}
					/>
				</svg>
			)
		}
		return nodeArray
	}

	const [isFakeLiked, setisFakeLiked] = useState(false)
	const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
	const [modalVisibility, setModalVisibility] = useState(false)
	const likeValue = likesInfo ? likesInfo.like : ''

	const formatNumber = num => {
		if (num > 999_999) {
			return `${parseInt(num / 1_000_000, 10).toString()}M`
		} else if (num > 999) {
			return `${parseInt(num / 1000, 10).toString()}K`
		} else {
			return num
		}
	}

	const handleLike = () => {
		if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
			const payloadLike = {
				type: 'PRODUCTO',
				idCMS: idProduct,
			}
			ProductService.setAnomLikes(payloadLike)
				.then(res => {
					if (res.status === 200) {
						if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
							const copyLocalLikes = JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS'))
							localStorage.setItem(
								'LOCAL_LIKES_PRODUCTS',
								JSON.stringify(copyLocalLikes.concat(idProduct))
							)
							setlocalLikes(copyLocalLikes.concat(idProduct))
						} else {
							localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([idProduct]))
							setlocalLikes([idProduct])
						}
						isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
					} else {
						console.log(res)
					}
				})
				.catch(e => console.log(e))
			return
		}
		const payloadc = {
			type: 'PRODUCTO',
			idCMS: idProduct,
		}
		const config = {
			headers: {
				Authorization: SessionService.getIdTokenData(),
			},
		}
		ProductService.setAuthLikes(payloadc, config)
			.then(res => {
				if (res.status === 200) {
					if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
						const copyLocalLikes = JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS'))
						localStorage.setItem(
							'LOCAL_LIKES_PRODUCTS',
							JSON.stringify(copyLocalLikes.concat(idProduct))
						)
						setlocalLikes(copyLocalLikes.concat(idProduct))
					} else {
						localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([idProduct]))
						setlocalLikes([idProduct])
					}
					isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
				} else {
					console.log(res)
				}
			})
			.catch(e => console.log(e))
	}

	const handleUnLike = () => {
		if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
			const payloadUnlike = {
				type: 'PRODUCTO',
				idCMS: idProduct,
			}

			ProductService.setAnomUnLikes(payloadUnlike)
				.then(res => {
					if (res.status === 200) {
						const copyLocalLikes = JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS'))
						localStorage.setItem(
							'LOCAL_LIKES_PRODUCTS',
							JSON.stringify(copyLocalLikes.filter(item => item !== idProduct))
						)
						setlocalLikes(copyLocalLikes.filter(item => item !== idProduct))
						isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
						return
					}
					console.log(res)
				})
				.catch(e => console.log(e))
			return
		}
		const payload = {
			type: 'PRODUCTO',
			idCMS: idProduct,
		}
		const config = {
			headers: {
				Authorization: SessionService.getIdTokenData(),
			},
		}

		ProductService.setAuthUnLikes(payload, config)
			.then(res => {
				if (res.status === 200) {
					const copyLocalLikes = JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS'))
					localStorage.setItem(
						'LOCAL_LIKES_PRODUCTS',
						JSON.stringify(copyLocalLikes.filter(item => item !== idProduct))
					)
					setlocalLikes(copyLocalLikes.filter(item => item !== idProduct))
					if (isFakeLiked) {
						setisFakeLiked(false)
					} else {
						setisFakeUnLiked(true)
					}
					return
				}
				console.log(res)
			})
			.catch(e => console.log(e))
	}

	const handleValidRedirect = (_event, { actionCard, isSent, producto }) => {
		_event.preventDefault()
		if (!isSelectedSample && !isSent && actionCard) {
			actionCard(producto)
		} else {
			window.location.href = `${homeLink}productos/${producto.slug}`
		}
	}

	const onProductDatalayer = () => {
		const userInfo = dataLayerUserInfo()
		const tagAgregar = { ...(dataLayerbody || {}) }
		tagAgregar.params.flow_type = isFreeSamples ? 'muestra gratis' : 'compra'
		;(tagAgregar.params.user_data = userInfo.user_data ? userInfo.user_data : ''),
			(tagAgregar.params.log_status = userInfo.log_status),
			pushGtagEvent(tagAgregar)
	}

	const retailsDataLayer = () => {
		pushDataLayerEvent({
			event: 'buy_now_list_retailers',
			single_item_id: dataLayerbody.params
				? dataLayerbody.params.items[0].item_id
				: dataLayerbody.item_id,
			single_item_name: dataLayerbody.params
				? dataLayerbody.params.items[0].item_name
				: dataLayerbody.item_name,
		})
	}

	const productClickDataLayer = () => {
		pushDataLayerEvent({
			event: 'product_click',
			single_item_id: dataLayerbody.params.items[0].item_id,
			single_item_name: dataLayerbody.params.items[0].item_name,
			link_text: isFreeSamples ? 'AGREGAR' : 'QUIERO SABER MÁS',
			link_url: `${homeLink}productos/${producto.slug}`,
		})
	}

	const replaceCategory = (slugSection, slugProduct) => {
		if (slugSection !== 'muestra-gratis/' && slugSection !== 'pide-tu-muestra/') return slugProduct

		const sectionsToReplace = /cuidadores\/|mujeres\/|hombres\//gim
		return slugProduct.replace(sectionsToReplace, '').replace('//', '/')
	}

	const handleLikeToggle = e => {
		e.preventDefault()
		e.stopPropagation()
		isLocalLiked ? handleUnLike() : handleLike()
	}

	return (
		<>
			{isBrowser && (
				<a
					onClick={evt => {
						localStorage.setItem('indexProductDetail', indexProduct)
						onProductDatalayer()
						productClickDataLayer()
						onClick && onClick(evt)
						handleValidRedirect(evt, { actionCard, isSent, producto })
					}}
					href={
						modeAction
							? `${homeLink}${slug || ''}${replaceCategory(slug, producto.slug) || ''}`
							: `${homeLink}productos/${producto.slug}`
					}
					className={`f-card-product ${noFooter ? 'no-footer' : ''} ${
						isSent ? 'f-card-product-disabled' : ''
					}`}
				>
					<div
						className={`f-card-product-header f-productos ${
							isSent ? 'f-card-product-header-disabled' : ''
						}`}
					>
						{isFreeSamples && imgMuestra !== null ? (
							<DynamicImage image={imgMuestra} alt='muestra' />
						) : imgProducto.file ? (
							<img
								className='f-card-product-header-img'
								src={imgProducto.file.url}
								alt={imgProducto.description}
							/>
						) : (
							<DynamicImage
								className='f-card-product-header-img'
								image={imgProducto}
								alt={imgProducto.description}
							/>
						)}
					</div>
					<div
						className={`f-card-product-body ${noHeight ? 'no-height' : ''} ${
							isSent ? 'f-card-product-body-disabled' : ''
						}`}
					>
						<div>
							<label className={'f-card-product-title f-productos'}>
								{producto.nombreProducto}
							</label>
							{!isFreeSamples && !isShortCard && (
								<div className='f-likes-container'>
									<div
										className={isLocalLiked ? 'f-icon-heart' : 'f-icon-heart-gray'}
										onClick={handleLikeToggle}
									/>
									<label className='f-count-likes'>
										{formatNumber(
											isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue
										)}
									</label>
								</div>
							)}
							{!isShortCard && (
								<p className='f-card-product-description'>
									{producto.descripcionImagenProductoPrevisualizacion}
								</p>
							)}
						</div>
						<div
							className={`f-comment-container${isShortCard ? ' f-comment-container--short' : ''}`}
						>
							{producto.nivelIncontinencia && (
								<label className='f-card-product-comment'>
									{producto.nivelIncontinencia &&
										documentToReactComponents(JSON.parse(producto.nivelIncontinencia.raw))}
								</label>
							)}
							<div className='f-drops-container'>
								{producto.numeroDeGotas &&
									renderDrops(producto.numeroDeGotas, producto.numeroDeGotasLlenas)}
							</div>
						</div>
					</div>
					{!noFooter &&
						(modeAction ? (
							<div
								className={`f-card-product-footer ${
									modeAction ? (isSelectedSample ? 'add-selected' : 'add') : ''
								} ${isSent ? 'f-card-product-button-disabled' : ''}`}
							>
								<label className='f-btn-label-redirect'>
									{convertText(
										isSent
											? ctaMuestraEnviada
											: (modeAction && modeAction[isSelectedSample ? 1 : 0]) || producto.ctaSaberMas
									)}
								</label>
								{modeAction && !isSent && <CheckIcon checked={isSelectedSample} />}
							</div>
						) : (
							<div className='f-card-product-footer f-product-buttons'>
								<div className='f-product-buttons__button f-product-buttons__button--primary'>
									{convertText(producto.ctaSaberMas)}
								</div>

								<button
									className='f-product-buttons__button f-product-buttons__button--secondary'
									onClick={e => {
										retailsDataLayer()
										e.preventDefault()
										e.stopPropagation()
										if (process.env.LOCALE === 'es-CO') {
											if (
												(producto.codigoDeProducto === 'TENA_PRODUCTO_006' ||
													producto.codigoDeProducto === 'TENA_PRODUCTO_005') &&
												producto.redireccionComprarEnLinea2
											) {
												window.location.href = producto.redireccionComprarEnLinea2
											} else {
												window.location.href = homeQueryRedirection.retailsDeCompra[0]
													.redireccionRetail
													? homeQueryRedirection.retailsDeCompra[0].redireccionRetail
													: 'https://tienda.tena.com.co/?utm_source=tena&utm_medium=boton-compra&utm_campaign=tienda-tena'
											}
										} else if (setModalShop) {
											setModalShop(true)
										} else {
											setModalVisibility(true)
										}
										if (onClickShop) {
											onClickShop()
										}
									}}
								>
									Ir a comprar
								</button>
							</div>
						))}
				</a>
			)}

			{modalVisibility && (
				<ModalRetails
					productInfo={producto}
					paramRetails={producto.retailsDelProducto}
					hideAction={() => {
						setModalVisibility(false)
					}}
				/>
			)}
		</>
	)
}

export default CardProduct
